import { getTime, differenceInMinutes } from "date-fns";
import { CallTaskState } from "../call-management.types.js";
const prioritizeCalls = (input) => {
  const priorityMap = {
    [CallTaskState.Open_Ringing]: 5,
    [CallTaskState.Open_InProgress]: 4,
    [CallTaskState.Open]: 3,
    [CallTaskState.Open_UnsuccessfulCallback]: 2,
    [CallTaskState.Done]: 1,
    [CallTaskState.Done_AvailyBooking]: 1,
    [CallTaskState.Ignored]: 0
  };
  const prioritizedCallTasks = input.map((callTask) => ({
    ...callTask,
    priority: priorityMap[callTask.currentState]
  }));
  const sortCalls = [...prioritizedCallTasks].sort((x, y) => {
    if (!x.latestIncomingCallAt)
      return 0;
    const currentDate = new Date(x.latestIncomingCallAt);
    const prevDate = new Date(y.latestIncomingCallAt);
    return getTime(prevDate) - getTime(currentDate);
  }).sort((x, y) => {
    if (!x.latestIncomingCallAt)
      return 0;
    const MINUTES = 15;
    const currentDate = new Date(x.latestIncomingCallAt);
    const prevDate = new Date(y.latestIncomingCallAt);
    const currentTime = getTime(currentDate);
    const prevTime = getTime(prevDate);
    const isNew = differenceInMinutes(/* @__PURE__ */ new Date(), currentDate) < MINUTES;
    return isNew ? currentTime - prevTime : prevTime - currentTime;
  }).sort((x, y) => {
    if (typeof y.priority === "number" && typeof x.priority === "number")
      return y.priority - x.priority;
    return 0;
  });
  return sortCalls;
};
export {
  prioritizeCalls
};
